import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Compass, Server, User, Users } from "lucide-react";
import AccountPanel from "./account/AccountsPanel";
import MembersPanel from "./members/MembersPanel";
import WalkthroughsPanel from "./walkthroughs/WalkthroughsPanel";
import PlatformPanel from "./platform/PlatformPanel";
import { useProfile } from "../../context/ProfileContext";
import { typography } from "../../styles/index";
import "./SettingsPage.css";

// Settings: the account, the org's members, the walkthroughs, and - for the platform admin only - every org. The sections are
// a row of pill tabs, as the Studio's New plan picks its source (NewPlan.css .np-sources); they wrap on a phone.
const SECTIONS = [
  { key: "account", icon: User, label: "Account" },
  { key: "members", icon: Users, label: "Members" },
  { key: "walkthroughs", icon: Compass, label: "Walkthroughs" },
  { key: "platform", icon: Server, label: "Platform", adminOnly: true },
];

export default function SettingsPage({ logout }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const { profile } = useProfile();
  const visible = SECTIONS.filter((s) => !s.adminOnly || profile?.role === "admin");
  const wanted = searchParams.get("section");
  const [section, setSection] = useState(visible.some((s) => s.key === wanted) ? wanted : "account");

  useEffect(() => {
    if (wanted && visible.some((s) => s.key === wanted)) setSection(wanted);
  }, [wanted]); // eslint-disable-line react-hooks/exhaustive-deps

  const choose = (key) => { setSection(key); setSearchParams({ section: key }, { replace: true }); };

  return (
    <div className="st-page">
      <h1 style={{ ...typography.h2, margin: 0 }}>Settings</h1>
      <div className="st-tabs" role="tablist" aria-label="Settings">
        {visible.map(({ key, label, icon: Icon }) => {
          const active = section === key;
          return (
            <button key={key} id={`${key}LeftNavSettings`} type="button" role="tab" aria-selected={active}
              className={`st-tab${active ? " is-active" : ""}`} onClick={() => choose(key)}>
              <Icon size={18} aria-hidden="true" /> {label}
            </button>
          );
        })}
      </div>
      <section role="tabpanel" aria-labelledby={`${section}LeftNavSettings`}>
        {section === "account" && <AccountPanel logout={logout} />}
        {section === "members" && <MembersPanel />}
        {section === "walkthroughs" && <WalkthroughsPanel />}
        {section === "platform" && <PlatformPanel />}
      </section>
    </div>
  );
}
